import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import FormSection from "../formSectionNew";
import localization from "assets/localization/localization";
import NonCollapseAccordion from "components/sales/accordion/nonCollapse/nonCollapse";
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { handleValidateObj } from 'constants/objValues/objvalues';
import DatePicker from 'components/sales/datePicker/datePicker';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import GateDataNew from "./dataAptNew";
import GateDuplicateNew from "./gateDuplicateNew";

const GateDetails = ({ data, handleValue, imageUploadUrl, videoUploadUrl, prefilledData,duplicate=true,inventoryEditable,setInventoryEditable }) => {

  const {gateSetup, gates_info } = data;
  const [gatesDetails, setGatesDetails] = useState([]);
  const [gateDatas, setGateDatas] = useState([]);
  const gatesInputs = {};
  const gatesPhotos = {};
  const gatesVideos = {};
  const [gatesData, setGatesData] = useState(gatesInputs);
  const [isHardware, setIsHardware] = useState('');
  const [duplacteNum, setduplacteNum] = useState(null);
  const [gatePhotos, setGatePhotos] = useState(gatesPhotos);
  const [gateVideos, setGateVideos] = useState(gatesVideos);
  const [current_name, setCurrent_name] = useState('');
  const [internetAvailabilty, setInternetAvailabilty] = useState('');
  const isloading = [{ name: 'Loding...', id: 1 }];
  const [inputList, setInputList] = useState([{ firstName: "", lastName: "",listValue: "" }]);
  const [isEdit, setIsEdit] = useState(0);
  

  useEffect(() => {
    if (
      prefilledData?.gates_data !== undefined &&
      prefilledData?.gates_data !== null &&
      prefilledData?.gates_data !== '' &&
      prefilledData?.gates_data?.length > 0
    ) {
      const {
        gates_data
      } = prefilledData;
      setInputList(gates_data);
      setIsEdit(1);
    }
  }, [prefilledData]);

  const handleGateDtl = (val) => {
    if (val === null) {
      return false;
    }
    if (val !== undefined && val !== null) {
      if (gateDatas && gateDatas.length === 0) {
        gateDatas.push(val);
        setGateDatas([...gateDatas]);
      } else {
        const isThere = gateDatas.findIndex((obj) => obj.id === val.id);
        if (isThere === -1) {
          gateDatas.push(val);
          setGateDatas([...gateDatas]);
        } else {
          gateDatas.splice(isThere, 1);
          gateDatas.push(val);
          setGateDatas([...gateDatas]);
        }
      }
    }
  };

  useEffect(() => {
    if (handleValue && gateDatas.length > 0) {
      handleValue([...gateDatas]);
    } else {
      handleValue(null);
    }
  }, [gateDatas]);

  
// handle input change
const handleInputChange = (e, index) => {
  const { name, value } = e.target;
  const list = [...inputList];
  list[index][name] = value;
  setInputList(list);
};
const handleDuplicateChange = (e,id) =>{
  const { name, value } = e.target;
  if(value > 0){
    setduplacteNum(value);
  }else{
    setduplacteNum(null);
  }
};
 
// handle click event of the Remove button
const handleRemoveClick = index => {
  let userResponse = window.confirm("Item details will be changed!");
  if (userResponse) {
    setInventoryEditable(true)
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
    const list2 = [...gateDatas];
    list2.splice(index,1);
    setGateDatas(list2);
  }
};
// handle click event of the make duplicate button
const handleDuplicateClick = (index,newNum) => {
  let userResponse = window.confirm("Item details will be changed!");
  if (userResponse) {
    setInventoryEditable(true)
    const list2 = [...gateDatas];
    //  var arrayDuplicate =
    const tempArray = JSON.parse(JSON.stringify(inputList)); // deep copy
    for(var i=1;i<=newNum;i++){
      tempArray.push({ firstName: "", lastName: "",listValue: list2[index]});
    }
    
      setInputList(tempArray);
      setduplacteNum(null);
  }
   
};
// console.log('inputList', inputList)
// handle click event of the Add button
const handleAddClick = () => {
  let userResponse = window.confirm("Item details will be changed!");
  if (userResponse) {
    setInventoryEditable(true)
    setInputList([...inputList, { firstName: "", lastName: "",listValue: "" }]);
  }
};

return (
  <div className="App">
  {data && data.solution_type_name ? 
  inputList.map((x, id) => {
    return (
      <Fragment key={id}>
      <div className="card">
        <div className="card-header  n-card">Solution {id+1} Details 
        <span style={{ float: 'right' }}>Type : {data.solution_type_name} </span>
         {/* <span style=({'float' : 'right'}}>{data.solution_type_name}</span> */}
        
        </div>
        <div className="card-body">
          {x && x.listValue ?
              <GateDuplicateNew
                key={id}
                id={id}
                index={id}
                handleValue={handleGateDtl}
                data={data}
                imageUploadUrl={imageUploadUrl}
                videoUploadUrl={videoUploadUrl}
                prefilledData={x.listValue}
                gatePhoto={x.listValue.gate_photo}
                isEdit={isEdit}
              />

            :
              <GateDataNew
                key={id}
                id={id}
                index={id}
                handleValue={handleGateDtl}
                data={data}
                imageUploadUrl={imageUploadUrl}
                videoUploadUrl={videoUploadUrl}
                prefilledData={x}
                isEdit={isEdit}
              />
            }
            
          
          <div className="row ml-1">
           
            {inputList.length !== 1 &&
             <div className="col-md-2 col-xs-12 col-sm-12">
                <button
                className="btn btn-danger mr20"
                onClick={() => handleRemoveClick(id)}>Remove</button>
            </div>
            }
            
            <div className="col-md-2 col-xs-12 col-sm-12 text-right">
            {inputList.length - 1 === id && <button className="btn btn-primary" onClick={handleAddClick}>Add</button>}
            </div>
            {inputList.length === 1 &&
             <div className="col-md-2 col-xs-12 col-sm-12">
                
            </div>
            }
            {duplicate ? 
              
              <>
              {inputList.length - 1 === id && 
              <>
             <div className="col-md-2"></div>
              <div className="col-md-3 col-xs-12 col-sm-12">
              
              <div className="form-group">
                {/* <input type="number" className="form-control prefix-text empty indianrupee " autocomplete="off" value=""/> */}
               
              <input
                className="form-control"
                name="duplicateQty"
                // placeholder="Duplicate "
                onChange={e => handleDuplicateChange(e,id)}
                value={duplacteNum ?? ''}
              />
                 <label className="placeholder">Number Of Solution</label><label className="error "></label>
                </div>
               </div>
               
               <div className="col-md-3 col-xs-12 col-sm-12">
               <button className="btn btn-primary"  onClick={() => handleDuplicateClick(id,duplacteNum)}>Make Duplicate</button>
               </div>
              
              
              </>
              }
            </>
            : null }
          </div>

        {/* <div className="btn-box">
          
          
         
        </div> */}
        {/* <div style={{ marginTop: 20 }}>{JSON.stringify(data)}</div> */}
      </div>
      <br/>
      </div>
      </Fragment>
     
      
    );
  })
  : 
  <div className="card">
  <div className="card-header"><div className="card-header" variant="link">No Solution</div></div>
  <div className="card-body">
     <span style={{ color: 'red' }}> Please Contact to your Manager ! </span>
    </div>
  </div>
  }
</div>
);
// console.log(data);
  // return (
  //   <FormSection title={localization.gateDetails}>
  //     <NonCollapseAccordion data={gatesDetails} />
  //   </FormSection>
  // );
};

GateDetails.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

export default GateDetails;
